import React, { useEffect, useState } from "react";
import logo from "../../../assest/images/logo.png";
import { BASEURL } from "../../../utils/BaseUrl";
import { useMutation } from "react-query";
import axios from "axios";
import CircleLoading from "../../../common/Loading/CircleLoading";
import { useAuth } from "../../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/16/solid";

const SignIn = () => {
  const [data, setData] = useState({
    identifier: "",
    password: "",

    identifierStatus: "unchecked",
    passwordStatus: "unchecked",
  });
  const [showPassword, setShowPassword] = useState(false);
  const { setAuthenticated, token, setToken, setCurrentUser } = useAuth();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}/login`, values);
    },
  });

  useEffect(() => {
    localStorage.clear();
  }, []);
  useEffect(() => {
    const setfunction = () => {
      if (mutation.isSuccess) {
        setAuthenticated(mutation.isSuccess);
        localStorage.setItem(
          "authenticated",
          JSON.stringify(mutation.isSuccess)
        );
        localStorage.setItem("token", JSON.stringify(mutation.data.data));

        setToken(mutation.data.data);
        fetchUserData(mutation.data.data.access_token);
        navigate("/admin/dashboard");
      } else {
        setAuthenticated(mutation.isSuccess);
      }
    };
    setfunction();
  }, [mutation.data]);

  const fetchUserData = async (token) => {
    const response = await axios.get(`${BASEURL}me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    localStorage.setItem("currentUser", JSON.stringify(response.data));
    setCurrentUser(response.data);
  };

  const handleChange = (e) => {
    let newdata = { ...data };
    if (e.target.name == "identifier") {
      const allCharactersLengthRegex = new RegExp(
        "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
      );
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e.target.name == "password") {
      const allCharactersLengthRegex = new RegExp("^.{3,15}$");
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    }
    newdata[e.target.name] = e.target.value;
    setData(newdata);
  };

  const checkSubmit = () => {
    let status = true;

    if (
      data.identifierStatus == "success" &&
      data.passwordStatus == "success"
    ) {
      status = false;
    } else {
      status = true;
    }
    return status;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const values = {
      identifier: data.identifier,
      password: data.password,
    };
    mutation.mutate(values);
  };

  return (
    <div className="flex relative justify-center items-center h-screen w-full max-sm:px-4 sign-box ">
      <div className="otp-verfiy-bg">
        <svg
          id="wave"
          style={{ transform: "rotate(180deg)", transition: "0.3s" }}
          viewBox="0 0 1440 490"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0">
              <stop stop-color="rgba(243, 106, 62, 1)" offset="0%"></stop>
              <stop stop-color="rgba(255, 179, 11, 1)" offset="100%"></stop>
            </linearGradient>
          </defs>
          <path
            style={{ transform: "translate(0, 0px)", opacity: 1 }}
            fill="url(#sw-gradient-0)"
            d="M0,0L60,24.5C120,49,240,98,360,138.8C480,180,600,212,720,196C840,180,960,114,1080,114.3C1200,114,1320,180,1440,236.8C1560,294,1680,343,1800,310.3C1920,278,2040,163,2160,122.5C2280,82,2400,114,2520,138.8C2640,163,2760,180,2880,163.3C3000,147,3120,98,3240,138.8C3360,180,3480,310,3600,351.2C3720,392,3840,343,3960,269.5C4080,196,4200,98,4320,65.3C4440,33,4560,65,4680,98C4800,131,4920,163,5040,187.8C5160,212,5280,229,5400,269.5C5520,310,5640,376,5760,392C5880,408,6000,376,6120,302.2C6240,229,6360,114,6480,81.7C6600,49,6720,98,6840,114.3C6960,131,7080,114,7200,98C7320,82,7440,65,7560,98C7680,131,7800,212,7920,212.3C8040,212,8160,131,8280,122.5C8400,114,8520,180,8580,212.3L8640,245L8640,490L8580,490C8520,490,8400,490,8280,490C8160,490,8040,490,7920,490C7800,490,7680,490,7560,490C7440,490,7320,490,7200,490C7080,490,6960,490,6840,490C6720,490,6600,490,6480,490C6360,490,6240,490,6120,490C6000,490,5880,490,5760,490C5640,490,5520,490,5400,490C5280,490,5160,490,5040,490C4920,490,4800,490,4680,490C4560,490,4440,490,4320,490C4200,490,4080,490,3960,490C3840,490,3720,490,3600,490C3480,490,3360,490,3240,490C3120,490,3000,490,2880,490C2760,490,2640,490,2520,490C2400,490,2280,490,2160,490C2040,490,1920,490,1800,490C1680,490,1560,490,1440,490C1320,490,1200,490,1080,490C960,490,840,490,720,490C600,490,480,490,360,490C240,490,120,490,60,490L0,490Z"
          ></path>
        </svg>
      </div>
      <div className="px-4 py-12 lg:px-4 border w-96 rounded-lg login-box">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm flex items-center">
          <div className="sign-logo">
            <img alt="Your Company" src={logo} />
            <h1>Ashwin cold Forge</h1>
          </div>
        </div>
        <p
          className={`text-center ${
            mutation.error ? "opacity-1" : "opacity-0"
          } text-[red] font-bold text-lg`}
        >
          Invalid Credentials
        </p>
        <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-6" onSubmit={(e) => handleSubmit(e)}>
            <div>
              <label
                htmlFor="email"
                className="block text-lg font-medium leading-6 sing-in-label"
              >
                Email
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="identifier"
                  type="text"
                  value={data.identifier}
                  onChange={(e) => handleChange(e)}
                  className={`block w-full  py-1.5   placeholder:text-gray-400  sm:text-sm sm:leading-6 outline-none px-4 
                    ${
                    data.identifierStatus == "success"
                      ? "input-success"
                      : data.identifierStatus == "error"
                      ? "input-error"
                      : ""
                  }`}
                />
                {data.identifierStatus == "error" && (
                  <p className="text-speed-red font-medium text-sm mt-1">
                    Email Invalid
                  </p>
                )}
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between relative">
                <label
                  htmlFor="password"
                  className="block text-lg font-medium leading-6 sing-in-label"
                >
                  Password
                </label>
              </div>
              <div className="mt-2 relative">
                <input
                  id="password"
                  name="password"
                  maxLength={15}
                  type={showPassword ? "text" : "password"}
                  required
                  value={data.password}
                  onChange={(e) => handleChange(e)}
                  autoComplete="current-password"
                  className={`block w-full  py-1.5 placeholder:text-gray-400  outline-none   sm:text-sm sm:leading-6 px-4 relative ${
                    data.passwordStatus == "success"
                      ? "input-success"
                      : data.passwordStatus == "error"
                      ? "input-error"
                      : ""
                  }`}
                />

                {showPassword ? (
                  <EyeIcon
                    onClick={() => setShowPassword(false)}
                    className="w-5 h-5 absolute right-2 top-2"
                  />
                ) : (
                  <EyeSlashIcon
                    onClick={() => setShowPassword(true)}
                    className="w-5 h-5 absolute right-2 top-2"
                  />
                )}
                {data.passwordStatus == "error" && (
                  <p className="text-speed-red font-medium text-sm mt-1">
                    Your password should be at least 3 characters long
                  </p>
                )}
              </div>
            </div>

            <div>
              <div className="text-sm flex justify-end -mt-4 mb-2">
                <Link
                  to={"/forgotpassword"}
                  className="font-semibold forgot-password"
                >
                  Forgot password?
                </Link>
              </div>

              <button
                className={`signbutton ${
                  checkSubmit() ? "cursor-not-allowed" : "cursor-pointer"
                } `}
                disabled={checkSubmit()}
              >
                {mutation.isLoading ? <CircleLoading /> : "Sign In"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
